// client/src/components/OfflineModeIndicator.tsx
import React from 'react';
import { WifiOff, Wifi, Clock } from 'lucide-react';
// Removed useAuth import - not needed
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export function OfflineModeIndicator() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed top-4 right-4 z-40">
      <div className="flex items-center px-3 py-2 text-sm font-medium text-white bg-orange-500 rounded-lg shadow-lg">
        <WifiOff className="w-4 h-4 mr-2" />
        Offline Mode
      </div>
    </div>
  );
}